const CONTRACTS = {
  1: {
    UniswapMycEthPool: "0x66dD48889Df1Fc32cBa3aBfA2c453906d527eB2e",
    
    UniswapTcrEthPool: "0x10b5c63a0a94ec3036238190bc88608a02e91e2c",
    SushiswapTcrEthPool: "0xe55c3e83852429334a986b265d03b879a3d188ac",

    UniswapEthUsdcPool: "0x88e6a0c2ddd26feeb64f039a2c41296fcb3f5640",
    BalancerVault: "0xBA12222222228d8Ba445958a75a0704d566BF2C8",

    TCR: "0x9c4a4204b79dd291d6b6571c5be8bbcd0622f050",
    MYC: "0x4b13006980aCB09645131b91D259eaA111eaF5Ba",

    WETH: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    USDC: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
  },
  
  56: {
    // bsc mainnet
    Treasury: "0xa44E7252a0C137748F523F112644042E5987FfC7",
    BUSD: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    GMT: "0x99e92123eB77Bc8f999316f622e5222498438784",
    Vault: "0xc73A8DcAc88498FD4b4B1b2AaA37b0a2614Ff67B",
    Router: "0xD46B23D042E976F8666F554E928e0Dc7478a8E1f",
    Reader: "0x087A618fD25c92B61254DBe37b09E5E8065FeaE7",
    AmmFactory: "0xBCfCcbde45cE874adCB698cC183deBcF17952812",
    AmmFactoryV2: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
    OrderBook: "0x1111111111111111111111111111111111111111",
    OrderBookReader: "0x1111111111111111111111111111111111111111",
    MycMigrator: "0xDEF2af818514c1Ca1A9bBe2a4D45E28f260063f9",
    USDG: "0x85E76cbf4893c1fbcB34dCF1239A91CE2A4CF5a7",
    NATIVE_TOKEN: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    XGMT: "0xe304ff0983922787Fd84BC9170CD21bF78B16B10",
    GMT_USDG_PAIR: "0xa41e57459f09a126F358E118b693789d088eA8A0",
    XGMT_USDG_PAIR: "0x0b622208fc0691C2486A3AE6B7C875b4A174b317",
    GMT_USDG_FARM: "0x3E8B08876c791dC880ADC8f965A02e53Bb9C0422",
    XGMT_USDG_FARM: "0x68D7ee2A16AB7c0Ee1D670BECd144166d2Ae0759",
    USDG_YIELD_TRACKER: "0x0EF0Cf825B8e9F89A43FfD392664131cFB4cfA89",
    XGMT_YIELD_TRACKER: "0x82A012A9b3003b18B6bCd6052cbbef7Fa4892e80",
    GMT_USDG_FARM_TRACKER_XGMT: "0x08FAb024BEfcb6068847726b2eccEAd18b6c23Cd",
    GMT_USDG_FARM_TRACKER_NATIVE: "0xd8E26637B34B2487Cad1f91808878a391134C5c2",
    XGMT_USDG_FARM_TRACKER_XGMT: "0x026A02F7F26C1AFccb9Cba7C4df3Dc810F4e92e8",
    XGMT_USDG_FARM_TRACKER_NATIVE: "0x22458CEbD14a9679b2880147d08CA1ce5aa40E84",
    AUTO: "0xa184088a740c695E156F91f5cC086a06bb78b827",
    AUTO_USDG_PAIR: "0x0523FD5C53ea5419B4DAF656BC1b157dDFE3ce50",
    AUTO_USDG_FARM: "0xE6958298328D02051769282628a3b4178D0F3A47",
    AUTO_USDG_FARM_TRACKER_XGMT: "0x093b8be41c1A30704De84a9521632f9a139c08bd",
    AUTO_USDG_FARM_TRACKER_NATIVE: "0x23ed48E5dce3acC7704d0ce275B7b9a0e346b63A",
  },
  97: {
    // bsc testnet
    Vault: "0x1B183979a5cd95FAF392c8002dbF0D5A1C687D9a",
    Router: "0x10800f683aa564534497a5b67F45bE3556a955AB",
    Reader: "0x98D4742F1B6a821bae672Cd8721283b91996E454",
    AmmFactory: "0x6725f303b657a9451d8ba641348b6761a6cc7a17",
    AmmFactoryV2: "0x1111111111111111111111111111111111111111",
    OrderBook: "0x9afD7B4f0b58d65F6b2978D3581383a06b2ac4e9",
    OrderBookReader: "0x0713562970D1A802Fa3FeB1D15F9809943982Ea9",
    MycMigrator: "0xDEF2af818514c1Ca1A9bBe2a4D45E28f260063f9",
    USDG: "0x2D549bdBf810523fe9cd660cC35fE05f0FcAa028",
    GMT: "0xedba0360a44f885ed390fad01aa34d00d2532817",
    NATIVE_TOKEN: "0x612777Eea37a44F7a95E3B101C39e1E2695fa6C2",
    XGMT: "0x28cba798eca1a3128ffd1b734afb93870f22e613",
    GMT_USDG_PAIR: "0xe0b0a315746f51932de033ab27223d85114c6b85",
    XGMT_USDG_PAIR: "0x0108de1eea192ce8448080c3d90a1560cf643fa0",
    GMT_USDG_FARM: "0xbe3cB06CE03cA692b77902040479572Ba8D01b0B",
    XGMT_USDG_FARM: "0x138E92195D4B99CE3618092D3F9FA830d9A69B4b",
    USDG_YIELD_TRACKER: "0x62B49Bc3bF252a5DB26D88ccc7E61119e3179B4f",
    XGMT_YIELD_TRACKER: "0x5F235A582e0993eE9466FeEb8F7B4682993a57d0",
    GMT_USDG_FARM_TRACKER_XGMT: "0x4f8EE3aE1152422cbCaFACd4e3041ba2D859913C",
    GMT_USDG_FARM_TRACKER_NATIVE: "0xd691B26E544Fe370f39A776964c991363aF72e56",
    XGMT_USDG_FARM_TRACKER_XGMT: "0xfd5617CFB082Ba9bcD62d654603972AE312bC695",
    XGMT_USDG_FARM_TRACKER_NATIVE: "0x0354387DD85b7D8aaD1611B3D167A384d6AE0c28",
  },
  421611: {
    // arbitrum testnet
    Vault: "0x1b093EaCB2Db0aae5Ed5B068b72887c277537D06",
    Router: "0x7586Fc042eC2E442dB6331eF6395422828269Be0",
    VaultReader: "0xBE946D0d111840A3Ce912851f9C7027C6D9Ff0C5",
    Reader: "0x5Bfa867aBBc45d824D647b88Af67d606f24165EB",
    MlpManager: "0x23f1B98a8725eDa20a83c8706bA3136B260B152D",
    RewardRouter: "0x0a83c05d3Bd25127c270715E5cd9CA869697b948",
    RewardReader: "0xE6c94E0d0EA43FF89f0952E97eD3d2cD89DB4C12",

    // https://github.com/OffchainLabs/arbitrum/blob/950c2f91b2e951cd3764394e0a73eac3797aecf3/packages/arb-ts/src/lib/networks.ts#L65 
    NATIVE_TOKEN: "0xB47e6A5f8b33b3F17603C83a0535A9dcD7E32681",
    MLP: "0x4960Eb3D3686943E365f71602c778C8b484B80a9",
    TCR: "0xE28DB434b53bDDfe72e3Bb287c8345632baBdB7c",
    MYC: "0xE28DB434b53bDDfe72e3Bb287c8345632baBdB7c",
    ES_MYC: "0x7a35b1B704b1d3c1C3bC5617f065C70596361ac4",
    BN_MYC: "0xfd996af51A31816B45D9535659f9c46E12c53905",
    USDG: "0x8deAC518eE4a4F90b89F0aFdC80d31feFdBA39F7",

    StakedMycTracker: "0x07d61259194CF6760C5CdA1B91dB9B79141C25c4",
    BonusMycTracker: "0x499084321217E00926F7bBD45830B0e74268b6cF",
    FeeMycTracker: "0xAf3CCbfDCc5E1e66201BcCc91F5d82930E29d454",
    StakedMlpTracker: "0x4E4dF4396EC47a7E6BDd5e731Fde9Ce108a555Bb",
    FeeMlpTracker: "0x18dEa0cBf4f035f8733098C31D6405DfBE3F757f",

    StakedMycDistributor: "0x499084321217E00926F7bBD45830B0e74268b6cF",
    StakedMlpDistributor: "0x34964F6ad47aC4BcF2cC931839664934588Ce621",

    MycVester: "0x6D97a351D4E4b34fC299d087B35f4F2f3e1Ba872",
    MlpVester: "0xFe1775a8bd123D03f5f4588b36Bdd4CC45B5abE0",

    OrderBook: "0x88Bfc6DDbF07C22416fcC6A5a9010d0a5D81d50a",
    OrderExecutor: "0xD34beDa54de5Bc13dC592F93Be48CA7974D4bDd4",
    OrderBookReader: "0x13d7A71851f702eD0887D71Dd55Ca4E9e401ce11",
    PositionRouter: "0xD4aF631cEBA8C4c10a85015923F820A2ee98b119",
    PositionManager: "0xaDDb01160aAD06cDD225770cF10c7a98502F3eEd",

    ReferralStorage: "0xcDA344Dac3b6fA38245BAd1FD61900b68b3C8857",
    ReferralReader: "0x9A3d3D5Df8F105cadb1F67587ab49d42146D5389",

    FeeDistributor: "0x057B99E0112A0D9fDA7503bDc8b6995fA2ff997D",
    FeeDistributorReader: "0x55ce0A81b697f1eff846e8a56D3f303A5BE490b1"
  },
  42161: {
    // arbitrum mainnet
    Vault: "0xDfbA8AD57d2c62F61F0a60B2C508bCdeb182f855",
    Router: "0x3cd2F02B9e39ccC781d0C07fc0286F654e53A76D",
    VaultReader: "0x261f953172ed61155a3f18fF807139Abe8234196",
    Reader: "0x77AE0F7128C6AC9f0efdb8A6F0Aabd5b979Ea80e",
    MlpManager: "0x2DE28AB4827112Cd3F89E5353Ca5A8D80dB7018f",
    RewardRouter: "0xd98d8e458F7aD22DD3C1d7A8B35C74005eb52b0b",
    RewardReader: "0x676CF948e84560808EEfb7Af9D3a46e0d6A6F988",
    NATIVE_TOKEN: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    MLP: "0x752b746426b6D0c3188bb530660374f92FD9cf7c",
    TCR: "0xA72159FC390f0E3C6D415e658264c7c4051E9b87",
    MYC: "0xc74fe4c715510ec2f8c61d70d397b32043f55abe",
    ES_MYC: "0x7CEC785fba5ee648B48FBffc378d74C8671BB3cb",
    BN_MYC: "0xb97f91bd8f7fb6ac761Fb84cB953e4F52f049486",
    USDG: "0xe61a61B9Ce1Bd12e17a53AeeeE1005Ef6C1b2E80",
    StakedMycTracker: "0x2BC8E28f5d41a4b112BC62EB7Db1B757c85f37Ff",
    BonusMycTracker: "0xbF86a15fa2604dbA2ad7E843c589FAAAd78bF318",
    FeeMycTracker: "0x0cA0147c21F9DB9D4627e6a996342A11D25972C5",
    StakedMlpTracker: "0xF7Bd2ed13BEf9C27a2188f541Dc5ED85C5325306",
    FeeMlpTracker: "0xF0BFB95087E611897096982c33B6934C8aBfA083",

    StakedMycDistributor: "0x3169b5719B8a7b40580965E8557379Fe15209aAD",
    StakedMlpDistributor: "0xB000f7dF69d74a1F3b3cdb8ddEB3317a0823af2b",

    MycVester: "0x67fF0614F6E4E04362B3b919Adc7371884895Ae8",
    MlpVester: "0xCB6ac1EacF498118f4609462c0979fFB3eBD1821",

    OrderBook: "0x2EeEf7852a306a580acF94F7c18C3FF124A59d4f",
    OrderExecutor: "0xC4e695a2ae9fd060E24Cdb87874b684dB7447a18",
    OrderBookReader: "0x1044345924277FD2e9bdF14Edad8C1d1a67a4B8e",

    PositionRouter: "0xE510571cAc76279DADf6c4b6eAcE5370F86e3dC2",
    PositionManager: "0x3892b8cF646b17709C91E653319bA5504a5FEafe",

    UniswapMycTcrPool: "0xc9f423c406e690b7f7715f9e048489caafb2266b",
    // TODO this uniswap pool has low liquidity so cant use for pricing
    UniswapMycEthPool: "0x6a034ac28064ffa8375e4668f4ecebdf3aafcba0",
    UniswapTcrEthPool: "0xe8bfb2918853576f0965e29bb86001ea93019003",

    BalancerVault: "0xBA12222222228d8Ba445958a75a0704d566BF2C8",

    ReferralStorage: "0x3Cd316df040f8A76eb2b496B92b358d3b2EFB9F5",
    ReferralReader: "0xb220724b6b68a84392eC22e841eDe5519863A21F",

    FeeDistributor: "0xc136c6a977af230B4F288dCE7f9432b0e91e4657",
    FeeDistributorReader: "0xe6d60D6A7d39d9435403e0993890D6B50B4B03BC"
  },
  43114: {
    // avalanche
    Vault: "0x9ab2De34A33fB459b538c43f251eB825645e8595",
    Router: "0x5F719c2F1095F7B9fc68a68e35B51194f4b6abe8",
    VaultReader: "0x80785f96743d5Aef7725d88256fdBCfF43fBd112",
    Reader: "0x2eFEE1950ededC65De687b40Fd30a7B5f4544aBd",
    MlpManager: "0xe1ae4d4b06A5Fe1fc288f6B4CD72f9F8323B107F",
    RewardRouter: "0x82147C5A7E850eA4E28155DF107F2590fD4ba327",
    RewardReader: "0x04Fc11Bd28763872d143637a7c768bD96E44c1b6",
    NATIVE_TOKEN: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    MLP: "0x01234181085565ed162a948b6a5e88758CD7c7b8",
    MYC: "0x62edc0692BD897D2295872a9FFCac5425011c661",
    ES_MYC: "0xFf1489227BbAAC61a9209A08929E4c2a526DdD17",
    BN_MYC: "0x8087a341D32D445d9aC8aCc9c14F5781E04A26d2",
    USDG: "0xc0253c3cC6aa5Ab407b5795a04c28fB063273894",

    StakedMycTracker: "0x2bD10f8E93B3669b6d42E74eEedC65dd1B0a1342",
    BonusMycTracker: "0x908C4D94D34924765f1eDc22A1DD098397c59dD4",
    FeeMycTracker: "0x4d268a7d4C16ceB5a606c173Bd974984343fea13",
    StakedMlpTracker: "0x9e295B5B976a184B14aD8cd72413aD846C299660",
    FeeMlpTracker: "0xd2D1162512F927a7e282Ef43a362659E4F2a728F",

    StakedMycDistributor: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
    StakedMlpDistributor: "0xDd593Cf40734199afc9207eBe9ffF23dA4Bf7720",

    MycVester: "0x472361d3cA5F49c8E633FB50385BfaD1e018b445",
    MlpVester: "0x62331A7Bd1dfB3A7642B7db50B5509E57CA3154A",

    OrderBook: "0x4296e307f108B2f583FF2F7B7270ee7831574Ae5",
    OrderExecutor: "0x4296e307f108B2f583FF2F7B7270ee7831574Ae5",
    OrderBookReader: "0xccFE3E576f8145403d3ce8f3c2f6519Dae40683B",

    PositionRouter: "0x195256074192170d1530527abC9943759c7167d8",
    PositionManager: "0xF2ec2e52c3b5F8b8bd5A3f93945d05628A233216",

    TraderJoeMycAvaxPool: "0x0c91a070f862666bbcce281346be45766d874d98",
    ReferralStorage: "0x827ed045002ecdabeb6e2b0d1604cf5fc3d322f8",
    ReferralReader: "0x505Ce16D3017be7D76a7C2631C0590E71A975083",
  },
};

export function getContract(chainId, name) {
  if (!CONTRACTS[chainId]) {
    throw new Error(`Unknown chainId ${chainId}`);
  }
  if (!CONTRACTS[chainId][name]) {
    throw new Error(`Unknown contract "${name}" for chainId ${chainId}`);
  }
  return CONTRACTS[chainId][name];
}

export const XGMT_EXCLUDED_ACCOUNTS = [
  "0x330eef6b9b1ea6edd620c825c9919dc8b611d5d5",
  "0xd9b1c23411adbb984b1c4be515fafc47a12898b2",
  "0xa633158288520807f91ccc98aa58e0ea43acb400",
  "0xffd0a93b4362052a336a7b22494f1b77018dd34b",
];
